module.exports = "/images/es-ga.svg?0c7e238db46ad58ed54f21651cc261e0";